function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Get uppy instance IDs for which state is stored.
 */
function findUppyInstances() {
  var instances = [];
  for (var i = 0; i < localStorage.length; i++) {
    var key = localStorage.key(i);
    if (key != null && key.startsWith('uppyState:')) {
      instances.push(key.slice('uppyState:'.length));
    }
  }
  return instances;
}

/**
 * Try to JSON-parse a string, return null on failure.
 */
function maybeParse(str) {
  try {
    return JSON.parse(str);
  } catch (_unused) {
    return null;
  }
}
var cleanedUp = false;
var MetaDataStore = /*#__PURE__*/function () {
  function MetaDataStore(opts) {
    _classCallCheck(this, MetaDataStore);
    this.opts = _objectSpread({
      expires: 24 * 60 * 60 * 1000
    }, opts);
    this.name = "uppyState:".concat(opts.storeName);
    if (!cleanedUp) {
      cleanedUp = true;
      MetaDataStore.cleanup();
    }
  }

  /**
   *
   */
  _createClass(MetaDataStore, [{
    key: "load",
    value: function load() {
      var savedState = localStorage.getItem(this.name);
      if (!savedState) return null;
      var data = maybeParse(savedState);
      if (!data) return null;
      return data.metadata;
    }
  }, {
    key: "save",
    value: function save(metadata) {
      var expires = Date.now() + this.opts.expires;
      var state = JSON.stringify({
        metadata: metadata,
        expires: expires
      });
      localStorage.setItem(this.name, state);
    }

    /**
     * Remove all expired state.
     */
  }], [{
    key: "cleanup",
    value: function cleanup(instanceID) {
      if (instanceID) {
        localStorage.removeItem("uppyState:".concat(instanceID));
        return;
      }
      var instanceIDs = findUppyInstances();
      var now = Date.now();
      instanceIDs.forEach(function (id) {
        var data = localStorage.getItem("uppyState:".concat(id));
        if (!data) return;
        var obj = maybeParse(data);
        if (!obj) return;
        if (obj.expires && obj.expires < now) {
          localStorage.removeItem("uppyState:".concat(id));
        }
      });
    }
  }]);
  return MetaDataStore;
}();
export { MetaDataStore as default };